module.exports = __webpack_public_path__ + "static/media/icon_textBox_error.63b87c97.svg";